/**
 * The name of the font has to be 100% the same as the one noted in _signatureFontFaces.scss
 */
export class Font {
  constructor(
    public id: string,
    public name: string,
    public baseSizeMultiplier = 1
  ) {}
}

export const Fonts = [
  new Font('fallind', 'Fallind', .85),
  new Font('grundschrift', 'grundschrift-beta'),
  new Font('beliya-signature', 'BeliyaSignature'),
  new Font('indie-flower-regular', 'IndieFlower-Regular'),
];
